import { useState } from 'react';
import {  useNavigate  } from "react-router-dom"; 
import {
  useMaterialUIController,
  setDarkMode
} from "context";

import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import DarkMode from '@mui/icons-material/DarkMode';
import LightMode from '@mui/icons-material/LightMode';
import Settings from '@mui/icons-material/Settings';
import { Dashboard } from '@mui/icons-material';
import Logout from '@mui/icons-material/Logout';
import Switch from "@mui/material/Switch";

import MDTypography from "dashboard/components/MDTypography";
import MDAvatar from 'dashboard/components/MDAvatar';

// hooks
import useLogout from "hooks/useLogout";

export default function AccountMenu({connectedUser}) {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const logOut = useLogout();
  const navigateTo = useNavigate();
  const signOut = async () => {
    await logOut();
    navigateTo("/");
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDarkMode = () => {
    setDarkMode(dispatch, !darkMode);
  }
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <MDAvatar sx={{ width: 44, height: 44 }} src={`${process.env.REACT_APP_PUBLIC_URL}/img/profil/${connectedUser.photoURL}`} alt="profile-image" size="md" shadow="sm" />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: ({palette}) => palette.background.card ,
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={()=>navigateTo(`/profil`, {state:{id:connectedUser.id}})}>
        <MDAvatar sx={{ width: 32, height: 32 }} src={`${process.env.REACT_APP_PUBLIC_URL}/img/profil/${connectedUser?.photoURL}`} alt="profile-image" size="md" shadow="sm" /> {connectedUser.displayName}
        </MenuItem>
        <Divider sx={{width:"100%"}} />
        <MenuItem>
          <ListItemIcon>
         {darkMode ? 
            <DarkMode sx={{ color :({palette}) => palette.text.main }} fontSize="small" />
            : <LightMode sx={{ color :({palette}) => palette.text.main }} fontSize="small" />
         }
          </ListItemIcon>
          <MDTypography variant="span">Light / Dark</MDTypography>
          <Switch checked={darkMode} onChange={handleDarkMode} />
        </MenuItem>
        <MenuItem onClick={()=>navigateTo(`/authentication/NewPass`)}>
          <ListItemIcon>
            <Settings sx={{ color :({palette}) => palette.text.main }} fontSize="small" />
          </ListItemIcon>
          Change password
        </MenuItem>
        {connectedUser && !["USER","PARTNER"].includes(connectedUser.isAdmin) && <MenuItem onClick={()=>navigateTo(`/dashboard`)}>
          <ListItemIcon>
            <Dashboard sx={{ color :({palette}) => palette.text.main }} fontSize="small" />
          </ListItemIcon>
          Tableau de bord
        </MenuItem>}
        <MenuItem onClick={signOut}>
          <ListItemIcon sx={{ color :({palette}) => palette.text.main }}>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}